var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.26538 12.7205C2.26893 11.724 2.26893 10.1041 3.26538 9.10764L5.59625 6.77677L4.48908 5.66961L2.15821 8.00048C0.549915 9.60878 0.549915 12.2193 2.15821 13.8276C3.76651 15.4359 6.37709 15.4359 7.98539 13.8276L10.3163 11.4968L9.20909 10.3896L6.87822 12.7205C5.88178 13.7169 4.26182 13.7169 3.26538 12.7205ZM6.23723 10.9141L10.899 6.25233L9.73354 5.08689L5.0718 9.74863L6.23723 10.9141ZM7.98539 2.17331L5.65452 4.50417L6.76168 5.61134L9.09255 3.28047C10.089 2.28402 11.7089 2.28402 12.7054 3.28047C13.7018 4.27691 13.7018 5.89687 12.7054 6.89331L10.3745 9.22418L11.4817 10.3313L13.8126 8.00048C15.4209 6.39218 15.4209 3.78161 13.8126 2.17331C12.2043 0.565006 9.59368 0.565007 7.98539 2.17331Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.d9d4a7923f5b90b6a23f34753b194d7c.svg";
export { ForwardRef as ReactComponent };